import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { isMobileAppRuntime } from 'utils';
import { isOnline } from 'mobile-modules/offline/state';

import Button from '@material-ui/core/Button';
import Modal from './Modal';

const styles = {
  btnWrapper: { textAlign: 'center', marginTop: '2rem' },
  container: { minWidth: '200px' },
  okBtn: { fontSize: '1.4rem' },
};

const InfoDialog = ({ info, showInfo, classes, translate }) => {
  const resetInfo = showInfo.bind(null, null);
  const rawMessage = info?.message == null ? '' : String(info.message);
  const visibleMessage = info?.html
    ? rawMessage.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim()
    : rawMessage.trim();
  const suppressEmptyMobileOffline = Boolean(
    info
    && isMobileAppRuntime()
    && !isOnline()
    && !visibleMessage
  );

  React.useEffect(() => {
    if (!suppressEmptyMobileOffline) return;

    const fs = window.Capacitor?.Plugins?.FLCOfflineStorage
      || window.Capacitor?.Plugins?.Filesystem
      || null;
    if (fs?.appendText) {
      const record = {
        time: new Date().toISOString(),
        type: 'offline-empty-info-dialog-render-suppressed',
        title: info?.title == null ? '' : String(info.title),
        message: rawMessage,
        pathname: window.location?.pathname || '',
      };
      Promise.resolve(fs.appendText({
        path: 'flc-offline-v1/diagnostics/missing-assets.jsonl',
        text: `${JSON.stringify(record)}\n`,
      })).catch(() => {});
    }

    showInfo(null);
  }, [info, rawMessage, showInfo, suppressEmptyMobileOffline]);

  if (suppressEmptyMobileOffline) return null;

  return (
    info && (
      <Modal on={!!info} toggle={resetInfo} bigZIndex={info.bigZIndex}>
        <div
          className={classes.container}
          style={{ textAlign: info.align || 'center' }}
        >
          {info.html ? (
            <div dangerouslySetInnerHTML={{ __html: info.message }} />
          ) : (
            <p>{info.message}</p>
          )}

          <div className={classes.btnWrapper}>
            <Button
              onClick={resetInfo}
              className={classes.okBtn}
              variant="contained"
              color="primary"
            >
              {translate(191, 'Ok', true)}
            </Button>
          </div>
        </div>
      </Modal>
    )
  );
};

InfoDialog.propTypes = {
  info: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  showInfo: PropTypes.func.isRequired,
};

export default withStyles(styles)(InfoDialog);
